export default {
  props: {
    name: {
      type: String
    },
    id: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    required: {
      type: Boolean,
      default: false
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/mixins/form.js
// module id = 571
// module chunks = 0